import React from 'react';
import { PaymentMethod } from '~/types/Payment';
import PaymentTab from '../PaymentTab';

const TransferTab = ({
  onSubmit,
}: {
  onSubmit: (params: { method: PaymentMethod; description: string }) => void;
}) => {
  const handleSubmit = (desc: string) => {
    onSubmit({
      method: PaymentMethod.Transfer,
      description: desc,
    });
  };
  return <PaymentTab placeholder="Pilih Transfer" onSubmit={handleSubmit} />;
};

export default TransferTab;
